<script setup>
import { reactive } from 'vue';

// // Module imports
import PollBranding from './PollBranding.vue';
import { PollHeroOptions } from './pollHeroUtils';

// // Component imports
import FluxButton from '@/components/FluxButton/FluxButtonComp.vue';

// // Asset imports
// import overlayDividerHorizontalSrc from '@/assets/images/overlays/divider-horizontal-arrows.png';

const props = defineProps({
  inputBoxBackground: {
    type: Object,
    // required: true,
    default: reactive({
      background: 'darkmagenta',
    }),
  },
  isInteractionMobile: {
    type: Boolean,
    default: false,
  },
  adVoteState: {
    type: String,
    default: '',
  },
  adHeadline: {
    type: String,
    default: '',
  },
  adHeadlineColor: {
    type: String,
    default: 'rgba(11, 11, 11, 1)',
  },
  adTagline: {
    type: String,
    default: '',
  },
  adTaglineColor: {
    type: String,
    default: 'rgba(11, 11, 11, 1)',
  },
  preBrandCopy: {
    type: String,
    // required: true,
    default: 'Sponsored by',
  },
  pollOptions: {
    type: Array,
    // required: true,
    default: () => [
      {
        optionEntry: 'One',
        optionLabel: PollHeroOptions.OPTION1,
        optionIndex: 0,
        optionPosition: 1,
      },
      {
        optionEntry: 'Two',
        optionLabel: PollHeroOptions.OPTION2,
        optionIndex: 1,
        optionPosition: 2,
      },
      {
        optionEntry: 'Three',
        optionLabel: PollHeroOptions.OPTION3,
        optionIndex: 2,
        optionPosition: 3,
      },
    ],
  },
  focusIndex: {
    type: Number,
    // required: true,
    default: 0,
  },
  brandLogos: {
    type: Array,
    default: () => [],
  },
  breakUuid: {
    type: String,
    // required: true,
    default: '',
  },
});

const emit = defineEmits(['pollInputEmitted']);

const styleObjectHeadline = reactive({
  color: props.adHeadlineColor,
});

const styleObjectTagline = reactive({
  color: props.adTaglineColor,
});

// // PollInput functions

const handlePoke = (indexParam) => {
  if (props.isInteractionMobile) {
    emit('pollInputEmitted', indexParam);
  }
};
</script>

<template>
  <div class="poll-input" :class="{ 'is-interaction-mobile': props.isInteractionMobile }">
    <div class="poll-input__container">
      <!-- <div class="poll-input__container-wrapper-branding"> -->
      <div class="poll-input__wrapper">
        <div class="poll-input__backdrop" :style="inputBoxBackground"></div>

        <div class="poll-input__contents">
          <div class="poll-input__vote-state">
            <span class="poll-input__vote-state-copy">{{ props.adVoteState }}</span>
          </div>

          <div
            v-if="props.adHeadline"
            class="poll-input__tagline in-headline"
            :style="styleObjectHeadline"
          >
            <span class="poll-input__tagline-copy">{{ props.adHeadline }}</span>
          </div>
          <div
            v-else-if="props.adTagline && !props.adHeadline"
            class="poll-input__tagline in-tagline"
            :style="styleObjectTagline"
          >
            <span class="poll-input__tagline-copy">{{ props.adTagline }}</span>
          </div>

          <!-- <div class="poll-input__separator" :style="styleObjectTagline">
              <img class="poll-input__divider" :src="overlayDividerHorizontalSrc" />
            </div> -->

          <div class="poll-input__button-row" :style="styleObjectTagline">
            <div
              v-for="item in props.pollOptions"
              :key="item.optionPosition"
              class="poll-input__option-button"
            >
              <FluxButton
                :class="{ active: item.optionIndex === props.focusIndex }"
                :button-copy="item.optionEntry"
                @click="handlePoke(item.optionIndex)"
              />
            </div>
          </div>
        </div>

        <PollBranding
          v-if="props.brandLogos"
          :poll-pre-brand-copy="props.preBrandCopy"
          :poll-pre-brand-color="styleObjectTagline"
          :poll-brand-logos="props.brandLogos"
        />
      </div>
      <!-- </div> -->
    </div>
  </div>
</template>
